import React, { useState, useMemo, useEffect } from "react";
// react plugin used to create DropdownMenu for selecting items
import Select from 'react-select'
import './SelectCredentials.css'

const SelectCredentials = (props) => {
  const [value, setValue] = useState()
  const [options, setOptions] = useState([])
  const credential = props.credential
  const setCredential = props.setCredential

  const changeHandler = item => {
    setValue(item)
    credential['type'] = {_id: item.value}
    setCredential(credential)
  }

  useEffect(() => {

    let alternatives = []

    props.selectOptions?.map((item) => {
      let target = { value: item._id, label: item.name }

      alternatives.push(target)
      
      if (item._id == props.typeId)
        setValue(target)

    })

    setOptions(alternatives)

  }, [props.selectOptions, props.typeId])

  return (
    <div >
      <Select
        className="form-control-alternative"
        isDisabled={props.formDisabled}
        options={options}
        value={value}
        id="input-type"
        classNamePrefix="selecTypeId"
        onChange={changeHandler}
      />
    </div>
  );

}

export default SelectCredentials;
